import styled, { keyframes } from "styled-components";

export const TestimonialMain = styled.section`
  margin: 0 auto;
  padding: 80px 24px;
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 48px;
  
  @media (max-width: 768px) {
    padding: 60px 16px;
    gap: 32px;
  }
`;

export const TestimonialHeader = styled.div`
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  
  h2 {
    font-size: 48px;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 16px;
    background: linear-gradient(135deg, #ffffff 0%, #a8a8a8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  p {
    font-size: 18px;
    color: #808080;
    font-weight: 300;
  }
  
  @media (max-width: 768px) {
    h2 {
      font-size: 32px;
    }
    
    p {
      font-size: 16px;
    }
  }
`;

export const TestimonialGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

interface TestimonialCardProps {
  featured?: boolean;
}

export const TestimonialCard = styled.div<TestimonialCardProps>`
  background: ${props => props.featured 
    ? 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%)'
    : 'rgba(26, 26, 26, 0.5)'};
  border: 1px solid ${props => props.featured ? 'rgba(139, 92, 246, 0.3)' : '#2a2a2a'};
  border-radius: 16px;
  padding: 24px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: ${props => props.featured 
      ? 'linear-gradient(90deg, transparent, rgba(139, 92, 246, 0.5), transparent)'
      : 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent)'};
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover {
    transform: translateY(-4px);
    border-color: ${props => props.featured ? 'rgba(139, 92, 246, 0.5)' : '#3a3a3a'};
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
    
    &::before {
      opacity: 1;
    }
  }
  
  @media (max-width: 640px) {
    padding: 20px;
  }
`;

export const TestimonialContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  .review {
    font-size: 15px;
    line-height: 1.6;
    color: #d0d0d0;
    font-weight: 300;
    flex-grow: 1;
  }
  
  .author {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: auto;
    padding-top: 16px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    
    .author-info {
      .name {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        margin-bottom: 2px;
      }
      
      .role {
        font-size: 12px;
        color: #808080;
        font-weight: 300;
      }
    }
  }
`;

export const TestimonialStars = styled.div`
  display: flex;
  gap: 4px;
`;

export const TestimonialAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
    line-height: 1;
    user-select: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    background: #1a1a1a;
  }
`;

export const TrustedLogos = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 32px;
  padding-top: 48px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  margin-top: 24px;
  
  .logo-item {
    height: 32px;
    opacity: 0.4;
    transition: opacity 0.3s ease;
    filter: grayscale(100%);
    
    &:hover {
      opacity: 0.7;
    }
    
    img {
      height: 100%;
      width: auto;
      object-fit: contain;
    }
  }
  
  @media (max-width: 640px) {
    gap: 24px;
    padding-top: 32px;
    
    .logo-item {
      height: 24px;
    }
  }
`;

// Keep old exports for backward compatibility if needed
export const TestimonialMarqueeContent = styled.div`
  display: none;
`;

export const TestimonialMarqueeItem = styled.div`
  display: none;
`;

export const TestimonialSectionImg = styled.div`
  display: none;
`;